import { render, staticRenderFns } from "./DeveloperDashboard.vue?vue&type=template&id=610532e2&scoped=true"
import script from "./DeveloperDashboard.vue?vue&type=script&lang=js"
export * from "./DeveloperDashboard.vue?vue&type=script&lang=js"
import style0 from "./DeveloperDashboard.vue?vue&type=style&index=0&id=610532e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610532e2",
  null
  
)

export default component.exports